import CoverTienda from './images/la_nuderia_categoria1.jpg';
import CoverTienda2 from './images/la_nuderia_categoria2.jpg';
import CoverTienda3 from './images/la_nuderia_cursos2.jpg';
import CoverTienda4 from './images/PropiosEspejos.jpg';
import CoverTienda5 from './images/Reposera.jpg';


export const SliderItems = [
    {
        id: 1,
        img: "https://images.pexels.com/photos/10963913/pexels-photo-10963913.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        title: "MACRAME",
        description: "MACRAME",
        bg: "f5fafd",
    },
    {
        id: 2,
        img: "",
        title: "MACRAME",
        description: "MACRAME",
        bg: "f5f1ed",
    },
    {
        id: 3,
        img: "",
        title: "MACRAME",
        description: "MACRAME",
        bg: "f5f0f4",
    },
];


export const categories = [
    {
        id: 1,
        img: CoverTienda5, //"https://images.pexels.com/photos/6634726/pexels-photo-6634726.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        title: "Reposera en\nmacramé",
        category: "https://cursos.lanuderia.com/curso/66a2cd94e3d71024502344cd",
        button: 'Quiero aprender!',
        alt: 'reposera'
    },
    {
        id: 2,
        img: CoverTienda3, //"https://images.pexels.com/photos/6471700/pexels-photo-6471700.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        title: "Mis\nCursos",
        category: 'https://cursos.lanuderia.com',
        button: 'Quiero aprender!',
        alt: 'cursos'
    },
    {
        id: 3,
        img: CoverTienda4, //"https://images.pexels.com/photos/10964052/pexels-photo-10964052.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        title: "Hacé tus propios\nespejos",
        category: "https://cursos.lanuderia.com/curso/65fcf25fa3065ffe40e2253f",
        button: 'Quiero aprender!',
        alt: 'espejos'
    },
];

